import React, { useEffect } from 'react';

const ScheduleTab = ({ register,getEditData,setValue }) => {
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const shifts = ['Shift Start', 'Shift End', 'First Break Start', 'First Break End', 'Second Break Start', 'Second Break End', 'Third Break Start', 'Third Break End'];

  useEffect(() => {
    if (getEditData) {
      
      const schedules = typeof getEditData.schedules === 'string'
      ? JSON.parse(getEditData.schedules)
      : getEditData.schedules;
    
    schedules?.forEach(dayObj => {
      Object.keys(dayObj).forEach(day => {
        Object.keys(dayObj[day]).forEach(shift => {
           
          setValue(`schedules[${day.toLowerCase()}][${shift.toLowerCase().replace(/\s+/g, '_')}]`, dayObj[day][shift]);
        });
      });
    });
    }
  }, [getEditData,setValue]);

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Schedule</th>
            {days.map((day) => (
              <th key={day} className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                {day}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {shifts.map((shift) => (
            <tr key={shift}>
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                {shift}
              </td>
              {days.map((day) => (
                <td key={`${shift}-${day}`} className="px-6 py-4 whitespace-nowrap text-center">
                
                  <input
                    type="time"
                    {...register(`schedules[${day.toLowerCase()}][${shift.toLowerCase().replace(/\s+/g, '_')}]`)}
                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#009efb] focus:border-[#009efb] sm:text-sm"
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ScheduleTab; 